import * as $ from 'jquery';
import ViewportTracker from '../lib/ViewPortTracker';
import StickyItem from './StickyItem';

import * as variables from '../variables.js';

ViewportTracker.init(variables);

export default class StickyItems {
	constructor() {
		if (!document.getElementsByClassName('product__information--hasImages').length) {
			return;
		}

		/* Ensures the item sticks on load */
		if ( ViewportTracker.above('productLinear') ) {
			this.stickyContent.stick();
		}
		this.eventHandlerStateChange();
		window.addEventListener('resize', this.eventHandlerStateChangeCB);
	}

	/* Actual Sticky Items */
	private stickyContent: StickyItem = new StickyItem('.product__information--hasImages', {
		adjustTop : $('.header').innerHeight() + 20,
		container : $('<div id="productGridDrawer" />').appendTo('.product__grid'),
		widthSizer : $('.product__informationWrapper')
	});

	/* Events */
	private eventHandlerStateChange: Function = function(): void {
		if ( ViewportTracker.above('productLinear') ) {
			this.stickyContent.bindEvents();
		} else {
			this.stickyContent.unbindEvents();
		}
	};
	private eventHandlerStateChangeCB: EventListener = (event: Event): void => {
		this.eventHandlerStateChange();
	};
}